import Api from '@/services/Api'
export default {
  saveAddress (address, id) {
    return Api().put('/model/address/shop/'+id, address)
  },
  saveUserAddress(address, id) {
    return Api().put('/model/address/user/'+id, address)
  }
}
